import type { FetchOptions } from './fetchResponse';
import { fetchResponse } from './fetchResponse';

type GetExperimentalMutationParams<TData, TVariables, TResponse> = FetchOptions<
	TVariables,
	TResponse
> & {
	variables: TVariables;
	parseResult: (response: TResponse, variables: TVariables) => TData | Promise<TData>;
};

export async function experimentalMutate<TData, TVariables, TResponse>({
	url,
	method,
	headers,
	body,
	credentials,
	variables,
	parseResult,
	parseResponseOnSuccess,
}: GetExperimentalMutationParams<TData, TVariables, TResponse>) {
	const json = await fetchResponse<TVariables, TResponse>(
		{
			url,
			method,
			body,
			headers,
			credentials,
			parseResponseOnSuccess,
		},
		variables,
	);

	const data = await parseResult(json, variables);

	return { data };
}
